/* Generated from docs/design-mockups-v2/assets/essent-v2.js by scripts/port_assets.py.
   Edit the mockup source, not this file. */
/* ==========================================================================
   Essent Perfumes — Interaction layer v2 (D1 mockups)
   Ports to theme-dev/assets/essent.js + essent-slider.js at D2.
   Carries the fixes for bugs A2 (per-variant per-ml) and A3 (page-based dots).
   ========================================================================== */
(function () {
  'use strict';

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var $  = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var SHOP = window.ESSENT || {};
  var money = function (cents) {
    try {
      return new Intl.NumberFormat(SHOP.locale || 'en', {
        style: 'currency', currency: SHOP.currency || 'USD',
        minimumFractionDigits: cents % 100 === 0 ? 0 : 2
      }).format(Number(cents) / 100);
    } catch (e) { return '' + (Number(cents) / 100); }
  };

  /* ---------- 1. Scroll reveal ------------------------------------------ */
  function reveal() {
    var els = $$('.rv');
    if (reduced || !('IntersectionObserver' in window)) {
      els.forEach(function (e) { e.classList.add('in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        var d = Number(en.target.dataset.delay || 0);
        setTimeout(function () { en.target.classList.add('in'); }, d);
        io.unobserve(en.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
    els.forEach(function (e) { io.observe(e); });
  }

  /* Carousel moved to essent-slider.js (transform-based, loop + align aware) */

  /* ---------- 3. Tabs ---------------------------------------------------- */
  function tabs(root) {
    var btns = $$('[role="tab"]', root);
    btns.forEach(function (b) {
      b.addEventListener('click', function () {
        btns.forEach(function (o) {
          var on = o === b;
          o.setAttribute('aria-selected', on ? 'true' : 'false');
          o.tabIndex = on ? 0 : -1;
          var panel = document.getElementById(o.getAttribute('aria-controls'));
          if (panel) panel.hidden = !on;
        });
      });
      b.addEventListener('keydown', function (e) {
        var i = btns.indexOf(b), n = null;
        if (e.key === 'ArrowRight') n = btns[(i + 1) % btns.length];
        if (e.key === 'ArrowLeft')  n = btns[(i - 1 + btns.length) % btns.length];
        if (n) { e.preventDefault(); n.focus(); n.click(); }
      });
    });
  }

  /* ---------- 4. Accordion ------------------------------------------------ */
  function accordions() {
    $$('.acc__q').forEach(function (q) {
      q.addEventListener('click', function () {
        var item = q.closest('.acc__item');
        var open = item.classList.toggle('is-open');
        q.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
    // first item of each accordion opens by default (teardown pattern)
    $$('.acc').forEach(function (a) {
      var first = $('.acc__item', a);
      if (first && first.dataset.open !== 'false') $('.acc__q', first).click();
    });
  }

  /* ---------- 5. Wishlist (localStorage) ---------------------------------- */
  var WKEY = 'essent:wishlist';
  function wishGet() {
    try { return JSON.parse(localStorage.getItem(WKEY) || '[]'); } catch (e) { return []; }
  }
  function wishSet(list) {
    try { localStorage.setItem(WKEY, JSON.stringify(list)); } catch (e) {}
    paintWish();
  }
  function paintWish() {
    var list = wishGet();
    $$('[data-wish]').forEach(function (b) {
      b.setAttribute('aria-pressed', list.indexOf(b.dataset.wish) > -1 ? 'true' : 'false');
    });
    $$('[data-wish-count]').forEach(function (n) {
      n.textContent = list.length;
      n.style.display = list.length ? '' : 'none';
    });
  }
  function wishlist() {
    document.addEventListener('click', function (e) {
      var b = e.target.closest('[data-wish]');
      if (!b) return;
      e.preventDefault();
      var h = b.dataset.wish, list = wishGet(), i = list.indexOf(h);
      if (i > -1) list.splice(i, 1); else list.push(h);
      wishSet(list);
    });
    paintWish();
  }

  /* ---------- 6. Drawers (cart / search / filter / quick-view / menu) -----
     Same open/close model as the mockups, plus one addition the static pages
     had no need for: `is-fresh`.

     Cart lines animate in when the drawer OPENS. Without a marker they would
     replay that animation on every quantity change too, because each re-render
     replaces the line elements — the shopper taps "+" and the whole list
     re-enters, which reads as a glitch rather than as polish. `is-fresh` is set
     on open and cleared once the entrance has played, so a re-render into an
     already-open drawer swaps silently.                                     */
  var lastFocus = null;
  var freshTimer = null;

  function openDrawer(id) {
    var d = document.getElementById(id); if (!d) return;
    lastFocus = document.activeElement;
    d.classList.add('is-on');
    d.setAttribute('aria-hidden', 'false');
    var s = $('#scrim'); if (s) s.classList.add('is-on');
    document.body.style.overflow = 'hidden';

    if (!reduced) {
      d.classList.add('is-fresh');
      clearTimeout(freshTimer);
      freshTimer = setTimeout(function () { d.classList.remove('is-fresh'); }, 900);
    }

    var f = d.querySelector('button,a,input,select,textarea');
    if (f) f.focus();
  }

  function closeDrawers() {
    $$('.drawer').forEach(function (d) {
      d.classList.remove('is-on', 'is-fresh');
      d.setAttribute('aria-hidden', 'true');
    });
    var s = $('#scrim'); if (s) s.classList.remove('is-on');
    document.body.style.overflow = '';
    if (lastFocus) { lastFocus.focus(); lastFocus = null; }
  }

  function drawers() {
    document.addEventListener('click', function (e) {
      var o = e.target.closest('[data-open-drawer]');
      if (o) { e.preventDefault(); openDrawer(o.dataset.openDrawer); return; }
      if (e.target.closest('[data-close-drawer]') || e.target.id === 'scrim') {
        e.preventDefault(); closeDrawers();
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeDrawers();
      if (e.key !== 'Tab') return;

      // Keep Tab inside the open drawer. Without this the focus ring walks off
      // into the dimmed page behind the scrim, where nothing is clickable.
      var open = $('.drawer.is-on'); if (!open) return;
      var items = $$('a[href],button:not([disabled]),input:not([disabled]),select,textarea', open)
        .filter(function (el) { return el.offsetParent !== null; });
      if (!items.length) return;
      var first = items[0], last = items[items.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });
  }

  /* ---------- 7. Quick view ----------------------------------------------
     The mockup painted the drawer from a JS object. On the store the panel is
     rendered by Liquid (Section Rendering API) so it sees the real variants,
     inventory and metafields — no second copy of the product model in JS.   */
  function quickview() {
    var d = $('#quickview'); if (!d) return;
    var body = $('[data-qv-body]', d);
    var busy = false;

    function load(handle) {
      if (busy) return;
      busy = true;
      d.classList.add('is-loading');
      openDrawer('quickview');
      fetch(SHOP.root + 'products/' + handle + '?section_id=essent-quick-view', {
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      })
        .then(function (r) {
          if (!r.ok) throw new Error('quick view ' + r.status);
          return r.text();
        })
        .then(function (html) {
          // the section wrapper carries no styling of its own; take its contents
          var tmp = document.createElement('div');
          tmp.innerHTML = html;
          var inner = tmp.querySelector('[data-qv-panel]') || tmp;
          body.innerHTML = inner.innerHTML;
          paintWish();
          pdpGallery(body);
          if (window.EssentSlider) window.EssentSlider.init(body);
          var f = body.querySelector('button,a,input,select');
          if (f) f.focus();
        })
        .catch(function () {
          // never leave an empty drawer: send the shopper to the full page
          body.innerHTML = '<p class="muted" style="padding:32px 0;text-align:center">' +
            'Quick view is unavailable. <a class="link-u" href="' + SHOP.root +
            'products/' + handle + '">Open the full product page</a>.</p>';
        })
        .then(function () { busy = false; d.classList.remove('is-loading'); });
    }

    document.addEventListener('click', function (e) {
      var b = e.target.closest('[data-quickview]');
      if (!b) return;
      e.preventDefault();
      load(b.dataset.quickview);
    });
  }

  /* ---------- 8. PDP: variants, qty, sticky bar --------------------------
     BUG A2 FIX: per-ml is recomputed from the SELECTED variant, not from a
     static volume_ml metafield, so 8ml/12ml/EDP all read correctly.

     Every price string is rendered by Liquid onto the pill (data-price-html
     and friends) rather than formatted in JS, so currency, decimals and
     market-specific pricing stay correct in all four markets.              */

  // shared with quick view, which injects the same gallery markup
  function pdpGallery(scope) {
    var gal = $('.gal', scope), gdots = $('.gal__dots', scope);
    if (!gal || !gdots || gdots.children.length) return;
    var cells = $$('.gal__cell', gal);
    if (cells.length < 2) return;
    cells.forEach(function (_, i) {
      var b = document.createElement('button');
      b.type = 'button';
      b.setAttribute('aria-label', 'Image ' + (i + 1));
      b.addEventListener('click', function () {
        gal.scrollTo({ left: i * gal.clientWidth, behavior: reduced ? 'auto' : 'smooth' });
      });
      gdots.appendChild(b);
    });
    var gt;
    gal.addEventListener('scroll', function () {
      clearTimeout(gt);
      gt = setTimeout(function () {
        var i = Math.round(gal.scrollLeft / gal.clientWidth);
        Array.prototype.forEach.call(gdots.children, function (d, j) {
          d.setAttribute('aria-current', j === i ? 'true' : 'false');
        });
      }, 60);
    }, { passive: true });
    if (gdots.firstChild) gdots.firstChild.setAttribute('aria-current', 'true');
  }

  // meters animate to their real value once visible (PDP and quick view)
  function meters(scope) {
    var els = $$('[data-meter]', scope);
    if (!els.length) return;
    if (reduced || !('IntersectionObserver' in window)) {
      els.forEach(function (m) { m.style.transform = 'scaleX(' + (m.dataset.meter / 100) + ')'; });
      return;
    }
    var mio = new IntersectionObserver(function (ents) {
      ents.forEach(function (en) {
        if (!en.isIntersecting) return;
        en.target.style.transform = 'scaleX(' + (en.target.dataset.meter / 100) + ')';
        mio.unobserve(en.target);
      });
    }, { threshold: .3 });
    els.forEach(function (m) { mio.observe(m); });
  }

  function selectVariant(root, pill) {
    if (!pill || pill.disabled) return;
    $$('[data-size]', root).forEach(function (p) { p.setAttribute('aria-pressed', 'false'); });
    pill.setAttribute('aria-pressed', 'true');

    var d = pill.dataset;
    var set = function (sel, html) {
      $$(sel, root).forEach(function (el) { if (html != null) el.innerHTML = html; });
    };
    set('[data-price]', d.priceHtml);
    set('[data-perml]', d.permlHtml);
    $$('[data-compare]', root).forEach(function (el) {
      el.innerHTML = d.compareHtml || '';
      el.hidden = !d.compareHtml;
    });
    $$('[data-variant-label]', root).forEach(function (el) { el.textContent = d.label; });

    // every form on the page buys the selected variant, sticky bar included
    $$('[data-variant-id-input]').forEach(function (input) { input.value = d.variantId; });
    $$('[data-sticky-price]').forEach(function (el) { el.innerHTML = d.priceHtml; });
    var opt = $('[data-sticky-variant]');
    if (opt) opt.value = d.variantId;

    var sold = d.available === 'false';
    $$('[data-atc]').forEach(function (b) {
      b.disabled = sold;
      b.textContent = sold ? (b.dataset.soldLabel || 'Sold out') : (b.dataset.addLabel || 'Add to cart');
    });
    $$('[data-buy-now]').forEach(function (b) { b.hidden = sold; });

    // scarcity line follows the variant, and only when stock is genuinely low
    var low = d.inventory !== '' && d.inventory != null && Number(d.inventory) > 0 &&
              Number(d.inventory) <= Number(SHOP.lowStockThreshold || 15);
    $$('[data-scarcity]', root).forEach(function (el) {
      el.hidden = !low;
      var n = $('[data-scarcity-count]', el);
      if (n && low) n.textContent = d.inventory;
      var bar = $('[data-stock-bar]', el);
      if (bar && low) {
        bar.style.transform = 'scaleX(' +
          Math.max(0.06, Number(d.inventory) / Number(SHOP.lowStockThreshold || 15)) + ')';
      }
    });

    if (d.variantId && window.history && history.replaceState) {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', d.variantId);
      history.replaceState({}, '', url.toString());
    }
  }

  function pdp() {
    $$('[data-qty]').forEach(function (wrap) {
      var input = $('input', wrap);
      $$('button', wrap).forEach(function (b) {
        b.addEventListener('click', function () {
          var max = Number(input.max || 0);
          var v = Math.max(1, Number(input.value || 1) + Number(b.dataset.step));
          input.value = max > 0 ? Math.min(v, max) : v;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
    });

    // quantity on the sticky bar mirrors the main form
    document.addEventListener('change', function (e) {
      var q = e.target.closest('[data-qty] input'); if (!q) return;
      $$('[data-qty] input').forEach(function (o) { if (o !== q) o.value = q.value; });
    });

    var buy = $('[data-buy]');
    if (buy) {
      $$('[data-size]', buy).forEach(function (pill) {
        pill.addEventListener('click', function () { selectVariant(buy, pill); });
      });
      var sel = $('[data-sticky-variant]');
      if (sel) sel.addEventListener('change', function () {
        selectVariant(buy, $('[data-size][data-variant-id="' + sel.value + '"]', buy));
      });

      var bar = $('.stickybar');
      if (bar && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (ents) {
          bar.classList.toggle('is-on',
            !ents[0].isIntersecting && ents[0].boundingClientRect.top < 0);
        }, { threshold: 0 }).observe(buy);
      }
    }

    meters(document);
    pdpGallery(document);

    // Shopify serves product recommendations through its own section endpoint
    $$('[data-recommendations]').forEach(function (holder) {
      fetch(holder.dataset.url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function (r) { return r.ok ? r.text() : ''; })
        .then(function (html) {
          var tmp = document.createElement('div');
          tmp.innerHTML = html;
          var section = tmp.querySelector('.essent-product-row-section, section');
          if (!section) { holder.remove(); return; }
          holder.replaceWith(section);
          if (window.EssentSlider) window.EssentSlider.init(section);
          paintWish();
        })
        .catch(function () { holder.remove(); });
    });

    // recently viewed: the PDP records itself, the row renders from the list
    var rv = $('[data-recently-viewed]');
    var handle = SHOP.productHandle;
    if (handle) {
      var seen = [];
      try { seen = JSON.parse(localStorage.getItem('essent:seen') || '[]'); } catch (e) {}
      var list = seen.filter(function (h) { return h !== handle; });
      if (rv) renderCards(rv, list.slice(0, 4), '[data-recently-viewed-empty]');
      list.unshift(handle);
      try { localStorage.setItem('essent:seen', JSON.stringify(list.slice(0, 12))); } catch (e) {}
    }
  }

  /* ---------- 9. Bundle hotspots ------------------------------------------
     The mockup's bundle was display-only: the price beside each row was decor
     and the size select did nothing. On the store each row is a real variant
     picker, so the row price, the set total and the ids the form posts all
     have to stay in agreement.

     Money is never formatted here by choice. The shop's money_format is owned
     by the currency converter (Convercy), which wraps every amount in
     <span class=cvc-money> so its own MutationObserver can rewrite the figure
     for the visitor's currency. A price built as a plain string in JS would be
     the one number on the page the converter cannot reach — which is exactly
     the bug this replaces, where an <option> label read "$10.20" next to a row
     reading "Rs. 1,000.00". So: every per-variant price is rendered by Liquid
     onto its <option> and moved with innerHTML, element intact.

     The total is the one figure Liquid cannot pre-render for every
     combination. Rather than invent the wrapper, we learn it from the total's
     own server render — find where the number sits inside whatever markup came
     back, and substitute only the number. If the shape cannot be read, the
     total hides itself rather than show a figure that might be wrong.        */
  function bundle() {
    var root = $('[data-bundle]'); if (!root) return;

    function focus(n) {
      $$('[data-hotspot]', root).forEach(function (h) { h.classList.toggle('is-active', h.dataset.hotspot === n); });
      $$('[data-brow]', root).forEach(function (r) { r.classList.toggle('is-active', r.dataset.brow === n); });
    }
    $$('[data-hotspot]', root).forEach(function (h) {
      h.addEventListener('mouseenter', function () { focus(h.dataset.hotspot); });
      h.addEventListener('focus', function () { focus(h.dataset.hotspot); });
      h.addEventListener('click', function () { focus(h.dataset.hotspot); });
    });
    $$('[data-brow]', root).forEach(function (r) {
      r.addEventListener('mouseenter', function () { focus(r.dataset.brow); });
    });

    /* The two renderings Shopify's money_format can ask for. */
    function withDecimals(c) {
      return (c / 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    }
    function noDecimals(c) {
      return Math.round(c / 100).toLocaleString('en-US');
    }

    var totalEl = $('[data-bundle-total]', root);
    var shape = null;

    if (totalEl) {
      var seed = Number(totalEl.dataset.cents || 0);
      var html = totalEl.innerHTML;
      [withDecimals, noDecimals].forEach(function (fmt) {
        if (shape) return;
        var n = fmt(seed);
        var at = n ? html.indexOf(n) : -1;
        if (at > -1) {
          shape = { pre: html.slice(0, at), post: html.slice(at + n.length), fmt: fmt };
        }
      });
    }

    function retotal() {
      if (!totalEl) return;
      var cents = 0;
      $$('[data-brow-price]', root).forEach(function (el) { cents += Number(el.dataset.cents || 0); });
      totalEl.dataset.cents = cents;
      if (!shape) { totalEl.hidden = true; return; }
      totalEl.innerHTML = shape.pre + shape.fmt(cents) + shape.post;
    }

    root.addEventListener('change', function (e) {
      var sel = e.target.closest('[data-bundle-size]'); if (!sel) return;
      var opt = sel.options[sel.selectedIndex]; if (!opt) return;
      var row = sel.closest('[data-brow]'); if (!row) return;
      var price = row.querySelector('[data-brow-price]');
      if (price && opt.dataset.price) {
        price.innerHTML = opt.dataset.price;
        price.dataset.cents = opt.dataset.cents || 0;
      }
      retotal();
    });
  }

  /* ---------- 10b. Pause off-screen marquees ------------------------------ */
  function marquees() {
    var bars = $$('.marquee');
    if (!bars.length || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (ents) {
      ents.forEach(function (en) { en.target.classList.toggle('is-off', !en.isIntersecting); });
    }, { threshold: 0 });
    bars.forEach(function (b) { io.observe(b); });
  }


  /* ---------- 12. Shoppable gallery: filters + inline video --------------- */
  function gallery() {
    var root = $('[data-gallery]'); if (!root) return;
    var grid = $('[data-gal-grid]', root);
    var count = $('[data-gal-count]', root);
    var items = $$('[data-gal-item]', grid);

    function apply(tag) {
      var shown = 0;
      items.forEach(function (el) {
        var ok = tag === 'all' || (' ' + el.dataset.tags + ' ').indexOf(' ' + tag + ' ') > -1;
        el.hidden = !ok;
        if (ok) shown++;
        if (!ok) stop(el);
      });
      if (count) count.textContent = 'Showing ' + shown + ' of ' + items.length +
        (tag === 'all' ? ' posts' : ' posts tagged “' + tag + '”');
    }

    $$('[data-gal-filter]', root).forEach(function (b) {
      b.addEventListener('click', function () {
        $$('[data-gal-filter]', root).forEach(function (o) {
          var on = o === b;
          o.setAttribute('aria-selected', on ? 'true' : 'false');
          o.tabIndex = on ? 0 : -1;
        });
        apply(b.dataset.galFilter);
      });
    });

    function stop(el) {
      var v = el.querySelector('video');
      if (v && !v.paused) { v.pause(); el.classList.remove('is-playing'); }
    }
    grid.addEventListener('click', function (e) {
      var fig = e.target.closest('.ugc--video');
      if (!fig || e.target.closest('.ugc__chip')) return;
      var v = fig.querySelector('video'); if (!v) return;
      if (v.paused) {
        items.forEach(stop);
        v.play().then(function () { fig.classList.add('is-playing'); })
                .catch(function () { /* poster stays; nothing to do */ });
      } else { stop(fig); }
    });
    apply('all');
  }

  /* ---------- 13. Collection: filter + sort ------------------------------
     The mockup filtered the cards already in the DOM. A real collection is
     paginated, so client-side filtering would only ever filter the current
     page. This drives Shopify's native faceted filtering instead: every
     control is a real link or form control, and JS only swaps the rendered
     section in place so the page does not jump. With JS off, or if a fetch
     fails, the same links navigate normally and everything still works.   */
  function collection() {
    var root = $('[data-collection-root]'); if (!root) return;
    var sectionId = root.dataset.collectionRoot;
    var seq = 0;

    function swap(url, push) {
      var mine = ++seq;
      root.classList.add('is-busy');
      var target = new URL(url, window.location.origin);
      target.searchParams.set('section_id', sectionId);
      return fetch(target.toString(), { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function (r) {
          if (!r.ok) throw new Error('filter ' + r.status);
          return r.text();
        })
        .then(function (html) {
          if (mine !== seq) return;                 // a newer request already won
          var tmp = document.createElement('div');
          tmp.innerHTML = html;
          var fresh = tmp.querySelector('[data-collection-root]');
          if (!fresh) throw new Error('filter: no root in response');
          root.innerHTML = fresh.innerHTML;
          paintWish();
          if (window.EssentSlider) window.EssentSlider.init(root);
          if (push) history.pushState({ essent: true }, '', url);
          var count = $('[data-count]', root);
          if (count) count.setAttribute('aria-live', 'polite');
        })
        .catch(function () {
          if (mine === seq) window.location.href = url;   // fall back to a real load
        })
        .then(function () { if (mine === seq) root.classList.remove('is-busy'); });
    }

    // one mechanism for persona chips, applied-filter removals, clear-all,
    // sort options and pagination — they are all just links
    root.addEventListener('click', function (e) {
      var a = e.target.closest('[data-facet-link]');
      if (!a || e.metaKey || e.ctrlKey || e.shiftKey || a.target === '_blank') return;
      e.preventDefault();
      swap(a.href, true);
      if (a.dataset.closeAfter !== 'false') closeDrawers();
    });

    // drop empty values so the URL stays readable and shareable
    function formUrl(form) {
      var clean = new URLSearchParams();
      new URLSearchParams(new FormData(form)).forEach(function (v, k) {
        if (v !== '') clean.append(k, v);
      });
      var q = clean.toString();
      return form.action.split('?')[0] + (q ? '?' + q : '');
    }

    var deb;
    root.addEventListener('change', function (e) {
      // sort is a <select> in the toolbar
      var sel = e.target.closest('[data-sort]');
      if (sel) {
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', sel.value);
        url.searchParams.delete('page');
        swap(url.toString(), true);
        return;
      }
      // the filter form lives in the drawer: applies on change, no Apply button
      var form = e.target.closest('[data-facet-form]'); if (!form) return;
      clearTimeout(deb);
      deb = setTimeout(function () { swap(formUrl(form), true); },
                       e.target.type === 'number' || e.target.type === 'text' ? 500 : 0);
    });

    root.addEventListener('submit', function (e) {
      var form = e.target.closest('[data-facet-form]'); if (!form) return;
      e.preventDefault();
      clearTimeout(deb);
      swap(formUrl(form), true);
      closeDrawers();
    });

    window.addEventListener('popstate', function (e) {
      if (e.state && e.state.essent) swap(window.location.href, false);
    });
  }

  /* ---------- 14. Cart drawer --------------------------------------------
     Shopify's Cart AJAX API is the source of truth; the drawer body is
     re-rendered by Liquid after every mutation (Section Rendering API) so
     money formatting, discounts and line properties are always the server's,
     never a second implementation in JS.                                   */
  function bumpCount(el) {
    el.classList.remove('is-bumped');
    void el.offsetWidth;               // restart the animation on a repeat add
    el.classList.add('is-bumped');
  }

  function cartRender(state) {
    // header count can be painted immediately from the JSON response
    if (state && typeof state.item_count === 'number') {
      $$('[data-cart-count]').forEach(function (el) {
        var changed = el.textContent.trim() !== String(state.item_count);
        el.textContent = state.item_count;
        el.hidden = state.item_count === 0;
        if (changed && !reduced) bumpCount(el);
      });
    }
    var drawer = $('[data-cart-body]'); if (!drawer) return Promise.resolve();
    return fetch(SHOP.root + '?section_id=essent-cart-drawer',
                 { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var fresh = tmp.querySelector('[data-cart-body]');
        if (fresh) drawer.innerHTML = fresh.innerHTML;
        // The subtotal and the Checkout button sit in the drawer footer, outside
        // [data-cart-body]. Swapping only the body left both at their page-load
        // values, so a cart filled from an empty page kept a zero subtotal and a
        // disabled Checkout. innerHTML, not textContent: the money span has to be
        // recreated for Convercy's observer to reach it.
        var foot = $('[data-cart-foot]'), freshFoot = tmp.querySelector('[data-cart-foot]');
        if (foot && freshFoot) foot.innerHTML = freshFoot.innerHTML;
        var n = tmp.querySelector('[data-cart-count]');
        if (n) {
          $$('[data-cart-count]').forEach(function (el) {
            var changed = el.textContent.trim() !== n.textContent.trim();
            el.textContent = n.textContent;
            el.hidden = n.textContent.trim() === '0';
            if (changed && !reduced) bumpCount(el);
          });
        }
        if (window.EssentSlider) window.EssentSlider.init(drawer);
        paintWish();
      });
  }

  function cartError(msg) {
    var box = $('[data-cart-error]');
    if (!box) { window.alert(msg); return; }
    box.textContent = msg;
    box.hidden = false;
    setTimeout(function () { box.hidden = true; }, 6000);
  }

  function cartPost(url, body) {
    return fetch(SHOP.root + url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.json().then(function (data) {
        if (!r.ok) throw new Error(data.description || data.message || 'Cart error');
        return data;
      });
    });
  }

  function cart() {
    // the bundle adds every selected variant in a single request, so the
    // shopper never sees the cart open twice or a partial set land
    document.addEventListener('submit', function (e) {
      var form = e.target.closest('[data-bundle-form]'); if (!form) return;
      e.preventDefault();
      var btn = form.querySelector('[data-bundle-add]');
      if (btn) { btn.classList.add('is-busy'); btn.disabled = true; }
      var items = [];
      $$('[name="items[]"]', form).forEach(function (f) {
        if (f.value) items.push({ id: Number(f.value), quantity: 1 });
      });
      if (!items.length) return;
      cartPost('cart/add.js', { items: items })
        .then(function () { return cartRender(); })
        .then(function () { openDrawer('cart'); })
        .catch(function (err) { cartError(err.message); })
        .then(function () {
          if (btn) { btn.classList.remove('is-busy'); btn.disabled = false; }
        });
    });

    // add to cart from any single-product form (PDP, sticky bar, quick view)
    document.addEventListener('submit', function (e) {
      var form = e.target.closest('[data-cart-form]'); if (!form) return;
      e.preventDefault();
      var btn = form.querySelector('[data-atc]');
      if (btn) { btn.classList.add('is-busy'); btn.disabled = true; }
      var fd = new FormData(form);
      var payload = { items: [{ id: Number(fd.get('id')), quantity: Number(fd.get('quantity') || 1) }] };
      cartPost('cart/add.js', payload)
        .then(function () { return cartRender(); })
        .then(function () { openDrawer('cart'); })
        .catch(function (err) { cartError(err.message); })
        .then(function () {
          if (btn) { btn.classList.remove('is-busy'); btn.disabled = false; }
        });
    });

    // one-click add from a card (single-variant products only — multi-variant
    // cards open quick view instead, so nothing is ever added blind)
    document.addEventListener('click', function (e) {
      var add = e.target.closest('[data-add]');
      if (add) {
        e.preventDefault();
        add.classList.add('is-busy');
        cartPost('cart/add.js', { items: [{ id: Number(add.dataset.add), quantity: 1 }] })
          .then(function () { return cartRender(); })
          .then(function () { openDrawer('cart'); })
          .catch(function (err) { cartError(err.message); })
          .then(function () { add.classList.remove('is-busy'); });
        return;
      }

      var line = e.target.closest('[data-line-change]');
      if (!line) return;
      e.preventDefault();
      var row = line.closest('[data-line]');
      if (row) row.classList.add('is-busy');
      cartPost('cart/change.js', {
        line: Number(line.dataset.line),
        quantity: Number(line.dataset.lineChange)
      })
        .then(cartRender)
        .catch(function (err) { cartError(err.message); });
    });

    // typing a quantity straight into a cart line
    document.addEventListener('change', function (e) {
      var input = e.target.closest('[data-line-qty]'); if (!input) return;
      cartPost('cart/change.js', {
        line: Number(input.dataset.line),
        quantity: Math.max(0, Number(input.value || 0))
      })
        .then(cartRender)
        .catch(function (err) { cartError(err.message); });
    });
  }

  /* ---------- 15. Search overlay -----------------------------------------
     Shopify predictive search, rendered by Liquid so a result row is the same
     component as everywhere else and searches the whole catalogue, not the
     handful of products that happen to be on the page.                     */
  function search() {
    var box = $('#search'); if (!box) return;
    var input = $('[data-search-input]', box);
    var out = $('[data-search-results]', box);
    if (!input || !out) return;
    var idle = out.innerHTML;      // Liquid renders the resting state (popular searches)
    var seq = 0, deb;

    function render(q) {
      q = (q || '').trim();
      if (q.length < 2) { out.innerHTML = idle; return; }
      var mine = ++seq;
      out.setAttribute('aria-busy', 'true');
      var url = SHOP.root + 'search/suggest?q=' + encodeURIComponent(q) +
                '&resources[type]=product,collection,page&resources[limit]=6' +
                '&section_id=essent-search-results';
      fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function (r) {
          if (!r.ok) throw new Error('search ' + r.status);
          return r.text();
        })
        .then(function (html) {
          if (mine !== seq) return;
          var tmp = document.createElement('div');
          tmp.innerHTML = html;
          var fresh = tmp.querySelector('[data-search-results-inner]');
          out.innerHTML = fresh ? fresh.innerHTML : tmp.innerHTML;
          paintWish();
        })
        .catch(function () {
          if (mine !== seq) return;
          out.innerHTML = '<p class="muted small">Search is unavailable right now. ' +
            '<a class="link-u" href="' + SHOP.root + 'search?q=' + encodeURIComponent(q) +
            '">Open the full results page</a>.</p>';
        })
        .then(function () { if (mine === seq) out.removeAttribute('aria-busy'); });
    }

    input.addEventListener('input', function () {
      clearTimeout(deb);
      var v = input.value;
      deb = setTimeout(function () { render(v); }, 220);
    });

    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-open-search]')) {
        e.preventDefault();
        openDrawer('search');
        setTimeout(function () { input.focus(); }, 260);
      }
    });
  }

  /* ---------- 16. FAQ page: category tabs + live search ------------------- */
  function faqPage() {
    var tabs = $('[data-faq-tabs]'); if (!tabs) return;
    var groups = $$('[data-faq-group]');
    var input = $('[data-faq-search]');
    var count = $('[data-faq-count]');
    var empty = $('[data-faq-empty]');

    function showCat(key) {
      groups.forEach(function (g) { g.hidden = g.dataset.faqGroup !== key; });
      $$('[data-faq-cat]', tabs).forEach(function (b) {
        b.setAttribute('aria-pressed', b.dataset.faqCat === key ? 'true' : 'false');
      });
      if (count) count.textContent = '';
      if (empty) empty.hidden = true;
      $$('.acc__item').forEach(function (i) { i.hidden = false; });
    }
    $$('[data-faq-cat]', tabs).forEach(function (b) {
      b.addEventListener('click', function () { if (input) input.value = ''; showCat(b.dataset.faqCat); });
    });

    if (input) input.addEventListener('input', function () {
      var q = input.value.trim().toLowerCase();
      if (!q) { showCat(groups[0].dataset.faqGroup); return; }
      var hits = 0;
      groups.forEach(function (g) { g.hidden = false; });
      $$('[data-faq-cat]', tabs).forEach(function (b) { b.setAttribute('aria-pressed', 'false'); });
      $$('.acc__item').forEach(function (item) {
        var ok = item.textContent.toLowerCase().indexOf(q) > -1;
        item.hidden = !ok;
        if (ok) hits++;
      });
      groups.forEach(function (g) {
        g.hidden = !$$('.acc__item:not([hidden])', g).length;
      });
      if (count) count.textContent = hits + ' answer' + (hits === 1 ? '' : 's') + ' matching “' + input.value.trim() + '”';
      if (empty) empty.hidden = hits > 0;
    });
  }

  /* ---------- 17. Wishlist page + card fragments -------------------------
     Saved handles live in localStorage (no account required). The card markup
     comes from the same Liquid snippet the grids use, fetched per handle, so
     a saved product shows its real price, badges and availability rather than
     a stale copy written at save time. Also serves recently-viewed on the PDP. */
  function renderCards(grid, handles, emptySelector) {
    var empty = emptySelector ? $(emptySelector) : null;
    if (!handles.length) {
      grid.innerHTML = '';
      if (empty) empty.hidden = false;
      else grid.closest('[data-card-row]') && (grid.closest('[data-card-row]').hidden = true);
      return Promise.resolve(0);
    }
    if (empty) empty.hidden = true;
    grid.setAttribute('aria-busy', 'true');

    return Promise.all(handles.map(function (h) {
      return fetch(SHOP.root + 'products/' + h + '?section_id=essent-card-fragment',
                   { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function (r) { return r.ok ? r.text() : ''; })
        .catch(function () { return ''; });
    })).then(function (chunks) {
      var frag = document.createElement('div');
      // a product that was unpublished or deleted returns nothing and is skipped
      frag.innerHTML = chunks.join('');
      var cards = frag.querySelectorAll('[data-product]');
      grid.innerHTML = '';
      Array.prototype.forEach.call(cards, function (c) { grid.appendChild(c); });
      grid.removeAttribute('aria-busy');
      if (!cards.length) {
        if (empty) empty.hidden = false;
        var row = grid.closest('[data-card-row]');
        if (row && !empty) row.hidden = true;
      }
      paintWish();
      return cards.length;
    });
  }

  function wishlistPage() {
    var grid = $('[data-wishlist-grid]'); if (!grid) return;
    var countEl = $('[data-wishlist-count]');

    function render() {
      var list = wishGet();
      renderCards(grid, list, '[data-wishlist-empty]').then(function (n) {
        if (countEl) {
          countEl.textContent = n === 1 ? '1 saved fragrance' : n + ' saved fragrances';
        }
      });
    }

    // removing a heart on this page removes the card
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-wish]')) setTimeout(render, 0);
    });
    render();
  }

  /* ---------- 11. Boot ---------------------------------------------------- */
  function boot() {
    reveal();
    $$('[data-tabs]').forEach(tabs);
    accordions();
    wishlist();
    drawers();
    quickview();
    pdp();
    bundle();
    marquees();
    gallery();
    collection();
    cart();
    search();
    faqPage();
    wishlistPage();
  }

  document.addEventListener('shopify:section:load', function (e) {
    if (window.EssentSlider) window.EssentSlider.init(e.target);
    meters(e.target);
    pdpGallery(e.target);
    $$('.rv', e.target).forEach(function (el) { el.classList.add('in'); });
    $$('[data-tabs]', e.target).forEach(tabs);
    paintWish();
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();